import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://wayaquick.com';
const DEFAULT_TITLE = 'WAYAQUICK - Start accepting payments in minutes';
const DEFAULT_DESCRIPTION =
    'WayaQuick is one platform that lets you sell wherever your customers are — online, in-person, anywhere in the world';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

/**
 * Per-page <head> tags: title, description, canonical and Open Graph.
 * Drop <Seo title="..." description="..." /> at the top of each page component.
 * Pass `noindex` on pages search engines should not list (e.g. the 404 page).
 */
const Seo = ({ title, description = DEFAULT_DESCRIPTION, image = DEFAULT_IMAGE, noindex = false }) => {
    const { pathname } = useLocation();
    // Routes are case-insensitive (/Cookies === /cookies), so canonicalise to lowercase
    // with no trailing slash to avoid duplicate URLs.
    const path = pathname === '/' ? '/' : pathname.replace(/\/+$/, '').toLowerCase();
    const url = `${SITE_URL}${path}`;
    const fullTitle = title ? `${title} | WayaQuick` : DEFAULT_TITLE;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            {noindex
                ? <meta name="robots" content="noindex, follow" />
                : <link rel="canonical" href={url} />}

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="WayaQuick" />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
};

export default Seo;
